import { render } from "./NumberComponent.vue?vue&type=template&id=07c6999a&scoped=true"
import script from "./NumberComponent.vue?vue&type=script&lang=js"
export * from "./NumberComponent.vue?vue&type=script&lang=js"

import "./NumberComponent.vue?vue&type=style&index=0&id=07c6999a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c6999a"]])

export default __exports__